module.exports = __webpack_public_path__ + "media/images/athletes/1211-044cb5d7c5481367040b1caa4aa8f0c1.png";